import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";

export default function BrowseClasses() {
  const [, navigate] = useLocation();
  const searchParams = useSearch();

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    const lang = params.get("language");
    if (lang) {
      navigate(`/?language=${lang}`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [navigate, searchParams]);

  return null;
}
